'use strict';
import angular from 'angular';
import _ from 'lodash';

import serviceConnectionFormHtmlUrl from '../views/serviceConnectionForm.html';
import clusterServiceConnectionFormHtmlUrl from '../views/clusterServiceConnectionForm.html';

angular.module('ioServiceConnections.ctrls', [])
    .controller('ioServiceConnectionsController', ['$scope', '$modal', '$ioAlert', '$confirm', '$state', '$stateParams', 'ioServiceConnectionsService', 'UserService', '$rootScope', 'ClusterService', 'FormService', function($scope, $modal, $ioAlert, $confirm, $state, $stateParams, ConnectionService, UserService, $rs, ClusterService, FormService) {
        $scope.pushServices = [];
        $scope.allServiceConnections = [];
        $scope.serviceConnections = [];
        $scope.enableClusterView = false;
        $scope.isView = false;
        $scope.isEnable = false;
        $scope.service = {};
        $scope.disableBtnAction = false;
        if ($stateParams.serviceId) {
            $scope.serviceId = $stateParams.serviceId;
        }

        $scope.getPushServices = function() {
            $rs.loadingInProgress = true;
            $rs.loadertitle = "Fetching services";
            ConnectionService.getPushServices().then(function(response) {
                if (response.services) {
                    $scope.pushServices = response.services;
                    $rs.loadingInProgress = false;
                    $scope.getServiceConnections();
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Could not get push services.', 'error');
                $rs.loadingInProgress = false;
            });
        }

        var getClusterServiceConnections = function() {
            ConnectionService.getClusterServiceConnections().then(function(response) {
                if (response.clusterServiceConnections) {
                    $scope.clusterServiceConnections = response.clusterServiceConnections;
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Could not get push services.', 'error');
            });
        }

        $scope.showFilter = function(service) {
            $scope.service = angular.copy(service);
            $scope.isView = true;
            $scope.filterServiceConnections();
        }

        $scope.hideFilter = function() {
            $scope.service = {};
            $scope.isView = false;
            $scope.isEnable = false;
            $scope.serviceConnections = [];
            $scope.enableClusterView = false;
        }

        $scope.filterFn = function(con) {
            return con.y.indexOf($scope.usrSingle) > -1;
        }

        $scope.createServiceConnection = function(service, fromPush) {
            $scope.service.id = service.id;
            $scope.saveServiceConnection(null, fromPush);
        }

        $scope.getServiceConnections = function() {
            ConnectionService.getServiceConnections().then(function(response) {
                if (response.serviceConnections) {
                    _.each(response.serviceConnections, function(connection) {
                        connection.user_data = JSON.parse(connection.user_data);
                    });
                    $scope.allServiceConnections = response.serviceConnections;
                    _.each($scope.allServiceConnections, function(conn) {
                        conn.service_name = "";
                        var pushServiceObj = _.find($scope.pushServices, {
                            id: conn.service_id
                        });
                        if (pushServiceObj) {
                            conn.service_name = pushServiceObj.name;
                        }
                    });
                    $scope.filterServiceConnections();
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Could not get push services.', 'error');
            });
        }

        $scope.filterServiceConnections = function(isFiltered) {
            $scope.serviceConnections = [];
            $scope.clusterConnected = [];
            if ($scope.service && $scope.service.id) {
                if (isFiltered) {
                    _.each($scope.allServiceConnections, function(conn) {
                        _.each($scope.filteredIds, function(filter) {
                            if ($scope.service && filter.connectionId == conn.id && conn.service_id == $scope.service.id) {
                                conn.isDefault = filter.is_default;
                                $scope.serviceConnections.push(conn);
                            }
                        });
                    });
                } else {
                    _.each($scope.allServiceConnections, function(conn) {
                        if (conn.service_id == $scope.service.id) {
                            $scope.serviceConnections.push(conn);
                        }
                    });
                    _.each($scope.clusterServiceConnections, function(connection) {
                        if (connection.service_id == $scope.service.id) {
                            $scope.clusterConnected.push(connection);
                        }
                    });
                }
            } else {
                $scope.serviceConnections = $scope.allServiceConnections;
            }
        }

        $scope.setDefault = function(connection) {
            var obj = {
                "clusterId": ClusterService.clusterIds[0],
                "serviceId": $scope.service.id,
                "connectionId": connection.id
            }
            ConnectionService.setDefaultClusterServiceConnection(obj).then(function(response) {
                if (response.clusterServiceConnection) {
                    connection.isDefault = 1;
                    $ioAlert.show('Success!', 'Default connection updated', 'success');
                } else {
                    $ioAlert.show('Error!', 'Could not update default', 'error');
                }

            }, function(error) {
                $ioAlert.show('Error!', 'Could not update default', 'error');
            });
        }

        $scope.saveServiceConnection = function(serviceConnectionObj, fromPush) {
            $scope.isNew = (serviceConnectionObj == null);
            $modal.open({
                controller: function($scope, $modalInstance, data, ioServiceConnectionsService, $ioAlert) {
                    $scope.serviceConnectionObj = {};
                    $scope.pushServices = data.pushServices;
                    $scope.service = data.service;
                    $scope.isNew = true;
                    if (data.serviceConnectionObj) {
                        $scope.serviceConnectionObj.id = data.serviceConnectionObj.id;
                        $scope.serviceConnectionObj.serviceId = data.serviceConnectionObj.service_id;
                        $scope.serviceConnectionObj.clientToken = data.serviceConnectionObj.user_data.clientToken;
                        $scope.serviceConnectionObj.clientTokenSecret = data.serviceConnectionObj.user_data.clientTokenSecret;
                        $scope.serviceConnectionObj.userId = data.serviceConnectionObj.user_data.userId;
                        $scope.serviceConnectionObj.userName = data.serviceConnectionObj.user_data.userName;
                        $scope.serviceConnectionObj.password = data.serviceConnectionObj.user_data.password;
                        $scope.serviceConnectionObj.oauthTime = data.serviceConnectionObj.user_data.oauthTime;
                        $scope.titleText = "Update";
                        $scope.isNew = false;
                    } else {
                        $scope.titleText = "Create New";
                        $scope.serviceConnectionObj.serviceId = $scope.service.id;
                    }
                    $scope.save = function(serviceForm) {
                        if (serviceForm.$valid) {
                            var obj = {
                                "serviceId": $scope.serviceConnectionObj.serviceId,
                            }
                            var userData = {
                                "userName": $scope.serviceConnectionObj.userName,
                                "password": $scope.serviceConnectionObj.password,
                                "clientToken": $scope.serviceConnectionObj.clientToken,
                                "clientTokenSecret": $scope.serviceConnectionObj.clientTokenSecret,
                                "userId": $scope.serviceConnectionObj.userId,
                                "oauthTime": $scope.serviceConnectionObj.oauthTime,
                            }
                            obj.userData = JSON.stringify(userData);

                            if (data.serviceConnectionObj) {
                                obj.id = $scope.serviceConnectionObj.id;

                                ioServiceConnectionsService.updateServiceConnection(obj).then(function(response) {
                                    if (response.errors) {
                                        for (var i = 0, len = response.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', response.errors[i]);
                                        }
                                    } else if (response.serviceConnection) {
                                        response.serviceConnection.service_id = $scope.serviceConnectionObj.serviceId;
                                        $modalInstance.close(response.serviceConnection);
                                    } else {
                                        $ioAlert.show('Error', "Error Updating Service Connection");
                                    }
                                }, function(error) {
                                    console.log("Error Update Service Connection");
                                });
                            } else {
                                ioServiceConnectionsService.addServiceConnection(obj).then(function(response) {
                                    if (response.errors) {
                                        for (var i = 0, len = response.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', response.errors[i]);
                                        }
                                    } else if (response.serviceConnection) {
                                        $modalInstance.close(response.serviceConnection);
                                    } else {
                                        $ioAlert.show('Error', "Error Adding Service Connection");
                                    }

                                }, function(error) {
                                    console.log("Error Adding Service Connection");
                                });
                            }
                        }
                    };
                    $scope.cancel = function() {
                        $modalInstance.dismiss();
                    }
                },
                templateUrl: serviceConnectionFormHtmlUrl,
                resolve: {
                    data: function() {
                        return {
                            serviceConnectionObj: serviceConnectionObj,
                            service: $scope.service,
                            pushServices: $scope.pushServices
                        };
                    }
                },
                backdrop: 'static'
            }).result.then(function(serviceConnectionObj) {
                if ($scope.isNew) {
                    $scope.getServiceConnections();
                    //$scope.filterServiceConnections();
                    $ioAlert.show('Success', 'New Service Connection has been added successfully', 'success');
                } else {
                    $scope.getServiceConnections()
                    $ioAlert.show('Success', 'Service connection has been updated successfully', 'success');
                }
            }, function(cancel) {

            });
        }

        $scope.removeServiceConnection = function(serviceConnectionObj) {
            var index = $scope.serviceConnections.indexOf(serviceConnectionObj);
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this Service Connection?'
            }).then(function() {
                ConnectionService.deleteServiceConnection(serviceConnectionObj).then(function(response) {
                    if (response.errors) {
                        for (var i = 0, len = response.errors.length; i < len; i++) {
                            $ioAlert.show('ERROR!', response.errors[i], 'error');
                        }
                    } else {
                        $ioAlert.show('Service Connection Deleted', 'Service Connection has been deleted successfully', 'success');
                        $scope.getServiceConnections();
                    }
                });
            });
        }

        $scope.saveClusterServiceConnection = function(serviceConnectionObj) {
            $modal.open({
                controller: function($scope, $modalInstance, data, ioServiceConnectionsService, $ioAlert, ClusterService) {
                    $scope.serviceConnectionObj = {};
                    $scope.selectedClusters = [];
                    if (data.serviceConnectionObj) {
                        $scope.serviceConnectionObj = data.serviceConnectionObj;
                    }
                    $scope.clusters = angular.copy(ClusterService.clusters);

                    $scope.clusterHelper = function() {
                        _.each($scope.clusters, function(clusterObj) {
                            clusterObj.selected = false;
                            //clusterObj.is_default = false;
                        });
                        if (data.clusterServiceConnections) {
                            _.each(data.clusterServiceConnections, function(clusterObj) {
                                if (clusterObj.service_id == $scope.serviceConnectionObj.service_id && clusterObj.connection_id == $scope.serviceConnectionObj.id) {
                                    $scope.selectedClusters.push(clusterObj);
                                }
                            });
                        }
                        _.each($scope.selectedClusters, function(clusterObj) {
                            _.each($scope.clusters, function(cluster) {
                                if (clusterObj.cluster_id == cluster.id) {
                                    cluster.selected = true;
                                    /*if (clusterObj.cluster_id == "1") {
                                        cluster.is_default = true;
                                    }*/
                                }
                            });
                        });
                    }

                    $scope.selectCluster = function(cluster) {
                        if (cluster.selected === true) {
                            cluster.selected = false;
                        } else {
                            cluster.selected = true;
                        }
                    }

                    $scope.selectAllCluster = function() {
                        _.each($scope.clusters, function(cluster) {
                            cluster.selected = true;
                        });
                    }

                    $scope.save = function(serviceForm) {
                        if (serviceForm.$valid) {
                            var parmObj = {
                                clusterIds: [],
                                serviceId: $scope.serviceConnectionObj.service_id,
                                connectionId: $scope.serviceConnectionObj.id,
                                isDefault: "no"
                            }
                            _.each($scope.clusters, function(clusterObj) {
                                if (clusterObj.selected == true) {
                                    parmObj.clusterIds.push(clusterObj.id);
                                }
                            });
                            ioServiceConnectionsService.addClusterServiceConnection(parmObj).then(function(response) {
                                if (response.errors) {
                                    $ioAlert.show('Error!', response.errors[0], 'error');
                                } else {
                                    $modalInstance.close();
                                }
                            }, function(error) {
                                console.log("Error Update Cluster Service Connection");
                            });
                        }
                    };

                    $scope.cancel = function() {
                        $modalInstance.dismiss();
                    }

                    var init = function() {
                        $scope.clusterHelper();
                    };
                    init();
                },
                templateUrl: clusterServiceConnectionFormHtmlUrl,
                resolve: {
                    data: function() {
                        return {
                            serviceConnectionObj: serviceConnectionObj,
                            clusterServiceConnections: $scope.clusterServiceConnections
                        };
                    }
                },
                backdrop: 'static'
            }).result.then(function() {
                $ioAlert.show('', 'Business Unit Service Connection has been updated successfully', 'success');
                getClusterServiceConnections();
            }, function(cancel) {

            });
        };

        $scope.showClusterView = function() {
            if ($scope.enableClusterView === true) {
                $scope.enableClusterView = false;
                return false;
            }
            $scope.enableClusterView = true;
            mapClusterViewData();
        }

        var mapClusterViewData = function() {
            $scope.serviceClusters = angular.copy(ClusterService.clusters);
            _.each($scope.serviceClusters, function(clusterObj) {
                clusterObj.connections = [];
                _.each($scope.clusterServiceConnections, function(itemObj) {
                    if (itemObj.cluster_id == clusterObj.id && itemObj.service_id == $scope.service.id) {
                        var connObj = _.find($scope.serviceConnections, {
                            id: itemObj.connection_id
                        });
                        if (connObj) {
                            connObj = angular.copy(connObj);
                            connObj.is_default = itemObj.is_default;
                            clusterObj.connections.push(connObj);
                        }
                    }
                });
            });
        }

        $scope.setDefaultConnection = function(connObj, cluster) {
            var paramObj = {
                "clusterId": cluster.id,
                "serviceId": $scope.service.id,
                "connectionId": connObj.id
            }
            ConnectionService.setDefaultClusterServiceConnection(paramObj).then(function(response) {
                if (response.clusterServiceConnection) {
                    var index = _.findIndex($scope.clusterServiceConnections, {
                        id: response.clusterServiceConnection.id
                    });
                    _.each($scope.clusterServiceConnections, function(itemObj) {
                        if (itemObj.cluster_id == cluster.id && itemObj.service_id == $scope.service.id) {
                            itemObj.is_default = "0";
                        }
                    });
                    if (index) {
                        $scope.clusterServiceConnections[index] = response.clusterServiceConnection;
                    }
                    mapClusterViewData();
                    $ioAlert.show('Success!', 'Default connection updated', 'success');
                } else {
                    $ioAlert.show('Error!', 'Could not update default', 'error');
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Could not update default', 'error');
            });
        }

        /*
        * Handle get instance lock configuration
        */
        var getInstanceLockConfig = function() {
            FormService.getInstanceLockConfig().then(function(data) {
                if(data.instanceLocked) {
                    $scope.disableBtnAction = true;
                } else {
                    $scope.disableBtnAction = false;
                }

            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }

        var init = function() {
            ClusterService.initCluster($rs.userRole, 'hidden');
            $scope.getPushServices();
            getClusterServiceConnections();
            getInstanceLockConfig();
            UserService.adjustStickyHeader();
        };
        UserService.adjustStickyHeaderWindowResize();
        if ($rs.userRole && $rs.userRole.id) {
            init();
        } else {
            UserService.getCurrentUserRole().then(function() {
                $rs.userRole = UserService.userRole;
                init();
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }
    }]);